/** Shared copy for full info routes and footer in-page panel */

export const PATH_TO_INFO_PAGE_KEY = {
  '/contact': 'contact',
  '/about': 'about',
  '/careers': 'careers',
  '/stories': 'stories',
  '/press': 'press',
  '/corporate': 'corporate',
  '/payments': 'payments',
  '/shipping': 'shipping',
  '/cancellation': 'cancellation',
  '/terms': 'terms',
  '/security': 'security',
  '/privacy': 'privacy',
  '/sitemap': 'sitemap',
  '/grievance': 'grievance',
  '/epr': 'epr',
  '/faq': 'faq',
  '/help': 'faq',
};

export const getInfoPageKeyFromPath = (path) => PATH_TO_INFO_PAGE_KEY[path] || null;
export const INFO_PAGE_CONTENT = {
  about: {
    eyebrow: 'About Us',
    title: 'About Us',
    intro:
      'At Yelooo.in, we aim to deliver high-quality products at affordable prices while building trust and long-term relationships with our customers.',
    highlights: [
      'At Yelooo.in, we aim to deliver high-quality products at affordable prices while building trust and long-term relationships with our customers.',
    ],
    sections: [
      {
        title: 'About Yelooo.in',
        body: [
          'At Yelooo.in, we aim to deliver high-quality products at affordable prices while building trust and long-term relationships with our customers.',
        ],
      },
    ],
    sidebarTitle: 'About',
    sidebarItems: ['High-quality products', 'Affordable prices', 'Trust', 'Long-term relationships'],
  },
  contact: {
    eyebrow: 'Contact Us',
    title: 'Contact Us',
    intro:
      'Our support team is always ready to assist you. Reach out to us for any queries, concerns, or feedback-weâ€™re here to help.',
    highlights: [
      'Our support team is always ready to assist you.',
      'Reach out to us for any queries, concerns, or feedback-weâ€™re here to help.',
    ],
    sections: [
      {
        title: 'Support',
        body: [
          'Our support team is always ready to assist you. Reach out to us for any queries, concerns, or feedback-weâ€™re here to help.',
        ],
      },
      {
        title: 'Office Address',
        body: [
          'Yelooo',
          'Sr. No. 13, Banker Colony,',
          'Opp. Vaibhavi Hospital,',
          'Opp. Akashwani, Pune Solapur Road, Hadapsar, Pune-28.',
        ],
      },
    ],
    sidebarTitle: 'Reach us',
    sidebarItems: [
      'Yelooo',
      'Hadapsar, Pune',
      'YouTube: @yelooo.in1',
      'Instagram: @yelooo.in',
    ],
  },
  careers: {
    eyebrow: 'Careers',
    title: 'Careers',
    intro:
      'Be a part of Yelooo.in and grow your career with us. We believe in innovation, teamwork, and creating opportunities.',
    highlights: [
      'Be a part of Yelooo.in and grow your career with us.',
      'We believe in innovation, teamwork, and creating opportunities.',
    ],
    sections: [
      {
        title: 'Careers at Yelooo.in',
        body: [
          'Be a part of Yelooo.in and grow your career with us. We believe in innovation, teamwork, and creating opportunities.',
        ],
      },
    ],
    sidebarTitle: 'Careers',
    sidebarItems: ['Innovation', 'Teamwork', 'Opportunities'],
  },
  stories: {
    eyebrow: 'Yelooo Stories',
    title: 'Yelooo Stories',
    intro:
      'Explore our journey, milestones, and the experiences that shape our brand and connect us with our customers.',
    highlights: [
      'Explore our journey, milestones, and the experiences that shape our brand and connect us with our customers.',
    ],
    sections: [
      {
        title: 'Our Story',
        body: [
          'Explore our journey, milestones, and the experiences that shape our brand and connect us with our customers.',
        ],
      },
    ],
    sidebarTitle: 'Stories',
    sidebarItems: ['Journey', 'Milestones', 'Brand experiences'],
  },
  press: {
    eyebrow: 'Press',
    title: 'Press',
    intro:
      'Get the latest updates, announcements, and media highlights about Yelooo.in.',
    highlights: [
      'Get the latest updates, announcements, and media highlights about Yelooo.in.',
    ],
    sections: [
      {
        title: 'Press Updates',
        body: [
          'Get the latest updates, announcements, and media highlights about Yelooo.in.',
        ],
      },
    ],
    sidebarTitle: 'Press',
    sidebarItems: ['Updates', 'Announcements', 'Media highlights'],
  },
  corporate: {
    eyebrow: 'Corporate Information',
    title: 'Corporate Information',
    intro:
      'Access official details about our company, policies, and business operations.',
    highlights: [
      'Access official details about our company, policies, and business operations.',
    ],
    sections: [
      {
        title: 'Corporate Details',
        body: [
          'Access official details about our company, policies, and business operations.',
        ],
      },
    ],
    sidebarTitle: 'Corporate',
    sidebarItems: ['Company details', 'Policies', 'Business operations'],
  },
  payments: {
    eyebrow: 'Payments',
    title: 'Payments',
    intro:
      'We offer secure and reliable payment options to ensure a smooth and safe checkout experience.',
    highlights: [
      'We offer secure and reliable payment options to ensure a smooth and safe checkout experience.',
    ],
    sections: [
      {
        title: 'Payment Information',
        body: [
          'We offer secure and reliable payment options to ensure a smooth and safe checkout experience.',
        ],
      },
    ],
    sidebarTitle: 'Payments',
    sidebarItems: ['Secure', 'Reliable', 'Safe checkout'],
  },
  shipping: {
    eyebrow: 'Shipping',
    title: 'Shipping',
    intro:
      'We ensure fast and reliable delivery across India, with timely updates on your order stat',
    highlights: [
      'We ensure fast and reliable delivery across India, with timely updates on your order stat',
    ],
    sections: [
      {
        title: 'Shipping Information',
        body: [
          'We ensure fast and reliable delivery across India, with timely updates on your order stat',
        ],
      },
    ],
    sidebarTitle: 'Shipping',
    sidebarItems: ['Fast delivery', 'Reliable delivery', 'Order updates'],
  },
  cancellation: {
    eyebrow: 'Cancellation & Returns',
    title: 'Cancellation & Returns',
    intro:
      'Orders can be cancelled within a limited time. We offer exchange only-no returns or refunds.',
    highlights: [
      'Orders can be cancelled within a limited time after placing. Once processed or shipped, cancellation is not allowed.',
      'We follow an exchange-only policy-returns and refunds are not provided.',
      'Exchange is applicable only for damaged, defective, or incorrect products, and must be requested within the specified time with valid proof.',
      'Products must be unused and in original packaging.',
    ],
    sections: [
      {
        title: 'Cancellation & Exchange Policy',
        body: [
          'Orders can be cancelled within 12 hours of placing. After that, cancellation is not allowed.',
        ],
        items: [
          'We do not offer returns or refunds. Only exchange is available.',
          'Exchange is allowed only if:',
          'Product is damaged',
          'Wrong item is delivered',
          'Product has a defect',
          'Request must be made within 48 hours of delivery with photo/video proof.',
          'Product must be unused and in original packaging.',
          'Shipping charges:',
          'Our mistake -> We pay',
          'Customer reason -> Customer pays',
          'Exchange will be processed within 5-7 working days after approval.',
        ],
      },
    ],
    sidebarTitle: 'Policy',
    sidebarItems: ['12 hours cancellation', '48 hours exchange request', 'No returns or refunds'],
  },
  terms: {
    eyebrow: 'Terms of Use',
    title: 'Terms of Use',
    intro:
      'These Terms of Use apply when you create an account, shop, earn points, or use any other service on Yelooo.in. By ticking the agreement box at registration, you confirm that you have read and accepted these terms.',
    highlights: [
      'You must accept these terms to create a customer account.',
      'Accounts are for personal use. You are responsible for keeping your login details safe.',
      'Orders, cancellations, exchanges, points, and referral activity follow the policies published on this website.',
      'Misuse, fraud, or unauthorized activity may lead to account suspension or legal action.',
      'We may update these terms. The version accepted at registration is recorded on your account.',
    ],
    sections: [
      {
        title: '1. Account and eligibility',
        body: [
          'You must provide accurate information when you register. You are responsible for all activity under your account.',
          'A valid referral code is used at registration. If you do not enter one, Yelooo’s default company code is applied.',
          'We may suspend or deactivate an account that is inactive, incomplete, or used in a way that breaks these terms.',
        ],
      },
      {
        title: '2. Shopping, orders, and payments',
        body: [
          'Product details, prices, and stock are shown as available at the time of browsing and may change.',
          'Placing an order is an offer to buy. Fulfilment is handled by the assigned seller. Delivery status is updated as the order moves from pending to delivered.',
          'You may cancel an order only while it is still Pending, and within the cancellation window published in the Cancellation & Returns policy (currently 12 hours of placing).',
        ],
      },
      {
        title: '3. Cancellation, exchange, and refunds',
        body: [
          'Yelooo offers exchange only in defined cases such as damage, wrong item, or defect. There are no general returns or refunds except where required by law.',
          'Exchange requests follow the process and timelines on the Cancellation & Returns page.',
        ],
      },
      {
        title: '4. Network, points, and wallet',
        body: [
          'Referral codes, network trees, points, level benefits, and wallet vouchers are loyalty features of the platform. They are not a guarantee of income.',
          'Points and benefits are granted according to Admin configuration (for example redemption rate and level rules). Abuse of referrals, fake orders, or false offline receipts may result in points being reversed and the account being restricted.',
        ],
      },
      {
        title: '5. Offline purchases',
        body: [
          'If you shop in a partner store, you may upload a receipt for points. The seller (and Admin, where needed) must approve the submission. False or altered receipts are not allowed.',
        ],
      },
      {
        title: '6. KYC and your information',
        body: [
          'You may be asked to complete KYC (for example Aadhaar) and bank details for withdrawals or certain features. Documents must be genuine.',
          'How we use personal data is described in the Privacy Policy.',
        ],
      },
      {
        title: '7. Changes and contact',
        body: [
          'We may update these terms. Continued use of Yelooo.in after an update means you accept the revised terms for ongoing use of the site.',
          'For questions, use the Contact Us or Grievance Redressal pages. Office: Sr. No. 13, Banker Colony, Opp. Vaibhavi Hospital, Opp. Akashwani, Pune Solapur Road, Hadapsar, Pune-28.',
        ],
      },
    ],
    sidebarTitle: 'At registration',
    sidebarItems: ['Checkbox required', 'Terms + Privacy', 'Acceptance is recorded'],
  },
  security: {
    eyebrow: 'Security',
    title: 'Security',
    intro:
      'We prioritize your safety by using secure technologies and encryption to protect your personal and payment information. Our systems are regularly monitored to prevent unauthorized access and ensure a safe shopping experience.',
    highlights: [
      'We prioritize your safety by using secure technologies and encryption to protect your personal and payment information.',
      'Our systems are regularly monitored to prevent unauthorized access and ensure a safe shopping experience.',
    ],
    sections: [
      {
        title: 'Security Information',
        body: [
          'We prioritize your safety by using secure technologies and encryption to protect your personal and payment information. Our systems are regularly monitored to prevent unauthorized access and ensure a safe shopping experience.',
        ],
      },
    ],
    sidebarTitle: 'Security',
    sidebarItems: ['Secure technologies', 'Encryption', 'Monitoring'],
  },
  privacy: {
    eyebrow: 'Privacy',
    title: 'Privacy',
    intro:
      'Your privacy is important to us. We collect only necessary information to create your account, process your orders, run referrals and points, and improve your experience.',
    highlights: [
      'Your privacy is important to us.',
      'We collect only necessary information to process your orders and improve your experience.',
      'Your data is kept secure and is never sold or misused.',
      'We may use your information for communication, updates, and service improvements.',
    ],
    sections: [
      {
        title: 'Privacy Information',
        body: [
          'Your privacy is important to us. We collect only necessary information to process your orders and improve your experience. Your data is kept secure and is never sold or misused. We may use your information for communication, updates, and service improvements.',
        ],
      },
    ],
    sidebarTitle: 'Privacy',
    sidebarItems: ['Necessary information only', 'Secure data', 'No misuse'],
  },
  sitemap: {
    eyebrow: 'Sitemap',
    title: 'Sitemap',
    intro:
      'Our sitemap helps you easily navigate through all pages of Yelooo.in, including products, categories, and important information sections, ensuring a smooth browsing experience.',
    highlights: [
      'Our sitemap helps you easily navigate through all pages of Yelooo.in, including products, categories, and important information sections, ensuring a smooth browsing experience.',
    ],
    sections: [
      {
        title: 'Sitemap Information',
        body: [
          'Our sitemap helps you easily navigate through all pages of Yelooo.in, including products, categories, and important information sections, ensuring a smooth browsing experience.',
        ],
      },
    ],
    sidebarTitle: 'Sitemap',
    sidebarItems: ['Products', 'Categories', 'Important information sections'],
  },
  grievance: {
    eyebrow: 'Grievance Redressal',
    title: 'Grievance Redressal',
    intro:
      'We are committed to resolving customer concerns quickly and fairly. If you have any complaints or issues, you can contact our support team. We aim to address all grievances within a reasonable timeframe.',
    highlights: [
      'We are committed to resolving customer concerns quickly and fairly.',
      'If you have any complaints or issues, you can contact our support team.',
      'We aim to address all grievances within a reasonable timeframe.',
    ],
    sections: [
      {
        title: 'Grievance Information',
        body: [
          'We are committed to resolving customer concerns quickly and fairly. If you have any complaints or issues, you can contact our support team. We aim to address all grievances within a reasonable timeframe.',
        ],
      },
    ],
    sidebarTitle: 'Grievance',
    sidebarItems: ['Customer concerns', 'Support team', 'Reasonable timeframe'],
  },
  epr: {
    eyebrow: 'EPR Compliance',
    title: 'EPR Compliance',
    intro:
      'Yelooo.in follows Extended Producer Responsibility guidelines to ensure responsible waste management. We are committed to environmentally friendly practices, including proper disposal and recycling of packaging and materials.',
    highlights: [
      'Yelooo.in follows Extended Producer Responsibility guidelines to ensure responsible waste management.',
      'We are committed to environmentally friendly practices, including proper disposal and recycling of packaging and materials.',
    ],
    sections: [
      {
        title: 'EPR Information',
        body: [
          'Yelooo.in follows Extended Producer Responsibility guidelines to ensure responsible waste management. We are committed to environmentally friendly practices, including proper disposal and recycling of packaging and materials.',
        ],
      },
    ],
    sidebarTitle: 'EPR',
    sidebarItems: ['Waste management', 'Disposal', 'Recycling'],
  },
  faq: {
    eyebrow: 'FAQ',
    title: 'FAQ',
    intro:
      'Find answers to common questions about orders, payments, shipping, and more.',
    highlights: [
      'Find answers to common questions about orders, payments, shipping, and more.',
    ],
    sections: [
      {
        title: 'FAQ Information',
        body: [
          'Find answers to common questions about orders, payments, shipping, and more.',
        ],
      },
    ],
    faqs: [
      {
        question: 'How do I place an order on Yelooo?',
        answer: 'Browse products, add the items you want to your cart, and continue through checkout to place your order.',
      },
      {
        question: 'What payment experience does Yelooo.in provide?',
        answer: 'We offer secure and reliable payment options to ensure a smooth and safe checkout experience.',
      },
      {
        question: 'Can I track my delivery?',
        answer: 'Delivery updates are shared as the order moves through fulfillment. You can also contact support for additional help.',
      },
      {
        question: 'Can I cancel or return an order?',
        answer: 'Orders can be cancelled within a limited time. We offer exchange only-no returns or refunds.',
      },
      {
        question: 'What should I do if I have a payment or order issue?',
        answer: 'Please contact our support team for help with payment or order issues.',
      },
    ],
    sidebarTitle: 'FAQ',
    sidebarItems: ['Orders', 'Payments', 'Shipping', 'More'],
  },
};
